import { css } from '@emotion/react'
import { Theme } from '@mui/material/styles'

export const aalStatRow = ({ theme }: { theme: Theme }) => css`
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};
  padding: ${theme.spacing(0.5)} 0;
  font-size: 13px;
  color: ${theme.palette.primary.dark};
`

export const aalStatLabel = css`
  font-weight: 600;
`

export const aalStatValue = css`
  font-weight: 700;
`

export const aalStatNotAvailable = ({ theme }: { theme: Theme }) => css`
  color: ${theme.palette.text.secondary};
  font-style: italic;
`

export const aalStatInfoIcon = ({ theme }: { theme: Theme }) => css`
  font-size: 14px;
  color: ${theme.palette.text.secondary};
`
